import { AbacoWebModule, RouterReadyEvent, ApplicationReadyEvent } from '@abaco/web-common/src/app';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { createMenu } from './menu';
import FarmerRegistryModule from '@abaco/farm-registry/src/modules/farm-registry';

export const MODULE_ID = "malta_s4f_scp_bridge_module";

interface ExchangeUrlResponse {
    token: string;
    envUrl: string;
}

export default class MaltsaS4fScpBridge implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;
    private http!: HTTPClient;
    private farmRegistryModule!: FarmerRegistryModule;

    readonly id = MODULE_ID;
  
    private onMenuNavigation = async () => {
        const exchangeUrlResponse = await this.exchangeSsoToken();
        
        const cuaa = this.farmRegistryModule.vuexModule.farm?.cuaa;
        const token = exchangeUrlResponse.token;
        let url = exchangeUrlResponse.envUrl + "/crop-plan-client?";
        // const url = "http://localhost:9091"

        if(cuaa){
            url = url + "CUAA=" + cuaa + "&";
        }
        window.open(`${url}SSO_TOKEN=j2_${token}`, "_blank")?.focus();
    }

    menu = createMenu(this.onMenuNavigation)

    onRouterReady(event: RouterReadyEvent) {
        this.http = event.http;
    }

    onApplicationReady(event: ApplicationReadyEvent){
        this.farmRegistryModule = event.modules.find(m => m.id === FarmerRegistryModule.MODULE_ID) as FarmerRegistryModule;
        if(!this.farmRegistryModule) throw new Error("FarmerRegistryModule not found");
    } 

    dependsOn = {
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule()
    }

    public async exchangeSsoToken(): Promise<ExchangeUrlResponse>{
        const url = "/malta-scp-2-a4f-api/api/v1/malta-scp2a4f/exchange-sso-token";
        const res = await this.http.get(url);
        return res.data; 
    }
}
